import Modal from '../../components/Modal';
import { scrollToTop } from '../../utils/misc';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request from '../../utils/request';

class ActivityAndInterests {
    constructor() {
        this._container = document.querySelector('.js-activity-interests');
        this._form = undefined;
        this._exitModal = undefined;
        this._activityInitial = undefined;
        this._activityCurrent = undefined;
        this._marketingConsentInitial = undefined;
        this._marketingConsentCurrent = undefined;
        this._interestInitial = [];
        this._interestCurrent = [];
        this._communicationSubscriptionsInitial = [];
        this._communicationSubscriptionsCurrent = [];
        this._thirdPartyMarketingConsentInitial = undefined;
        this._thirdPartyMarketingConsentCurrent = undefined;
		this._myWimbledonOptInInitial = undefined;
        this._myWimbledonOptInCurrent = undefined;

        this._submitCta = undefined;
        this._exitCta = undefined;
        this._errorWrapper = undefined;
        this._hiddenClass = 'u-hidden';

        if (this._container){
            this.initActivityAndInterestsEdit();
        }
    }

    initActivityAndInterestsEdit() {
        this._form = SelectorEngine.findOne('#editActivityInterestsForm', this._container);
        const interestsWrapper = SelectorEngine.findOne('.js-interests-wrapper', this._container);
        const activitiesWrapper = SelectorEngine.findOne('.js-activities-wrapper', this._container);
        const interestInputs = SelectorEngine.find('input[name=interest]', interestsWrapper);
        const activityInputs = SelectorEngine.find('input[name=tennisPadelPlayer]', activitiesWrapper);
        const playingFrequencyWrapper = SelectorEngine.findOne('.js-activity-interests-regularly-play', this._container);
        const marketingConsent = SelectorEngine.findOne('#marketingConsent', this._container);
        const communicationSubscriptions = SelectorEngine.findOne('.js-activity-interests-marketing-preferences', this._container);
        const communicationSubscriptionsInputs = SelectorEngine.find('input[name=communicationSubscriptions]', this._container);
		
        //exit
        this._exitCta = SelectorEngine.findOne('.js-account-exit');

        // set initial and current values to use in hasChanges()
        this._interestInitial = [];
        this._interestCurrent = [];
        [...interestInputs].forEach((input) => {
            if (input.checked) {
                this._interestInitial.push(input.value);
                this._interestCurrent.push(input.value);
            }
        });
        [...activityInputs].forEach((input) => {
            if (input.checked) {
                this._activityInitial = input.value;
                this._activityCurrent = input.value;
            }

            input.addEventListener('change', (event) => {
                const value = event.target.value;
                if (value === 'no') {
                    playingFrequencyWrapper.classList.add(this._hiddenClass);
                } else {
                    playingFrequencyWrapper.classList.remove(this._hiddenClass);
                }
            });
        });

        [...communicationSubscriptionsInputs].forEach((input, index) => {
            this._communicationSubscriptionsInitial[index] = input.checked;
            this._communicationSubscriptionsCurrent[index] = input.checked;

            input.addEventListener('change', (event) => {
                this._communicationSubscriptionsCurrent[index] = false;
                if (event.target.checked) this._communicationSubscriptionsCurrent[index] = event.target.checked;  
            })
        });

        if (marketingConsent) {
            this._marketingConsentInitial = marketingConsent.checked;
            this._marketingConsentCurrent = marketingConsent.checked;
        }

        if (thirdPartyMarketingConsent) {
            this._thirdPartyMarketingConsentInitial = thirdPartyMarketingConsent.checked;
            this._thirdPartyMarketingConsentCurrent = thirdPartyMarketingConsent.checked;
        }

		if (myWimbledonOptIn) {
            this._myWimbledonOptInInitial = myWimbledonOptIn.checked;
            this._myWimbledonOptInCurrent = myWimbledonOptIn.checked;
        }

        interestsWrapper.addEventListener('click', (event) => {
            if (event.target.value) this._interestCurrent = Array.from(SelectorEngine.find("input[name=interest]:checked", this._container)).map(item => item.value)
        })
		
        activitiesWrapper.addEventListener('click', (event) => {
            if (event.target.value) this._activityCurrent = event.target.value;
        })

        marketingConsent.addEventListener('change', (event) => {
            const checked = event.target.checked;

            if (checked) {
                // communicationSubscriptions.classList.remove(this._hiddenClass); Removing these to match the current website. Need to check with the Business.
                this._marketingConsentCurrent = checked;
            } else {
                // communicationSubscriptions.classList.add(this._hiddenClass);
                this._marketingConsentCurrent = "no";
            }
        })

        thirdPartyMarketingConsent.addEventListener('change', (event) => {
            if (event.target.value) this._thirdPartyMarketingConsentCurrent = event.target.value;
            this._thirdPartyMarketingConsentCurrent = "no";
        })

		myWimbledonOptIn.addEventListener('change', (event) => {
            if (event.target.value) this._myWimbledonOptInCurrent = event.target.value;
            this._myWimbledonOptInCurrent = "no";
        })

        // modals
        this.handleActivityConfirmationModal();
        this.handleExitModal();

        // submit
        this._submitCta = SelectorEngine.findOne('.js-submit-activity-interest', this._container);
        this._submitCta.addEventListener('click', (event) => this.submitChanges(event));

        // error
        this._errorWrapper = SelectorEngine.findOne('.js-activity-interest--error', this._container);
        const errorDismissCta = SelectorEngine.findOne('.js-dismiss-activity-interest-error', this._container);
        errorDismissCta.addEventListener('click', () => {
            this._errorWrapper.classList.add(this._hiddenClass);
        });
    }

    handleActivityConfirmationModal() {
        const activityInputYes = SelectorEngine.findOne('input#yes', this._container);
        const activityInputNo = SelectorEngine.findOne('input#no', this._container);
        const playingFrequencyWrapper = SelectorEngine.findOne('.js-activity-interests-regularly-play', this._container);

        // Yes Confirmation Modal
        if (this._activityInitial === 'no'){

            const activityYesConfirmationModalElement = SelectorEngine.findOne('#activity-yes-confirmation-modal');
            const activityYesConfirmationModal = new Modal(activityYesConfirmationModalElement, {});
            const activityYesConfirmButton = SelectorEngine.findOne('.js-activity-confirm-btn', activityYesConfirmationModalElement);
            const activityYesCancelButton = SelectorEngine.findOne('.js-activity-cancel-btn', activityYesConfirmationModalElement);


            // click yes radio input
            activityInputYes.addEventListener('click', (event) => {
                // preventDefault() because if user clicks out of the modal it will close it without confirm the change
                event.preventDefault();
                activityYesConfirmationModal.show();
            });

            activityYesConfirmButton.addEventListener('click', () => {
                activityInputYes.checked = true;
                activityYesConfirmationModal.hide();
                playingFrequencyWrapper.classList.remove(this._hiddenClass);
            });

            activityYesCancelButton.addEventListener('click', () => {
                activityYesConfirmationModal.hide()
                activityInputNo.checked = true;
                this._activityCurrent = activityInputNo.id;
                playingFrequencyWrapper.classList.add(this._hiddenClass);
            });
        } else {
            // No Confirmation Modal
            const activityNoConfirmationModalElement = SelectorEngine.findOne('#activity-no-confirmation-modal');
            const activityNoConfirmationModal = new Modal(activityNoConfirmationModalElement, {});
            const activityNoConfirmButton = SelectorEngine.findOne('.js-activity-confirm-btn', activityNoConfirmationModalElement);
            const activityNoCancelButton = SelectorEngine.findOne('.js-activity-cancel-btn', activityNoConfirmationModalElement);

            // click no radio input
            activityInputNo.addEventListener('click', (event) => {
                // preventDefault() because if user clicks out of the modal it will close it without confirm the change
                event.preventDefault();
                activityNoConfirmationModal.show();
                playingFrequencyWrapper.classList.add(this._hiddenClass);
            });

            activityNoConfirmButton.addEventListener('click', () => {
                activityInputNo.checked = true;
                activityNoConfirmationModal.hide();
                playingFrequencyWrapper.classList.add(this._hiddenClass);
            });

            activityNoCancelButton.addEventListener('click', () => {
                activityNoConfirmationModal.hide()
                activityInputYes.checked = true;
                this._activityCurrent = activityInputYes.id;
                playingFrequencyWrapper.classList.remove(this._hiddenClass);
            });
        }
    }

    handleExitModal() {
        this._exitModal = new Modal(SelectorEngine.findOne('#exit-editing'), {});
        const backCta = SelectorEngine.findOne('.js-account-edit-back');

        backCta.addEventListener('click', (event) => {
            this.exitEditing(event);
        });

        this._exitCta.addEventListener('click', (event) => {
            this.exitEditing(event);
        });

        const exitModalCancel = SelectorEngine.findOne('.js-account-details-continue');
        exitModalCancel.addEventListener('click', () => this._exitModal.hide());

        const exitModalContinue = SelectorEngine.findOne('.js-account-details-exit');
        exitModalContinue.addEventListener('click', (event) => this.backToUrl(event));
    }

    async submitChanges(event) {
        event.preventDefault();
        this._exitCta.disabled = true;
        this._submitCta.disabled = true;

        if (this.hasChanges()) {
            const url = this._form.dataset.url;

            const formData = new FormData(this._form);
            const dataObject = {
                marketingConsent: "no",
                thirdPartyMarketingConsent: "no",
                myWimbledonOptIn: "no",
                communicationSubscriptions: [],
            };
            formData.forEach((value, key) => {
                if (['communicationSubscriptions', 'interest'].includes(key)) {
                    if (!dataObject[key]) {
                        dataObject[key] = [ value ];
                    } else {
                        dataObject[key].push(value);
                    }
                } else {
                    dataObject[key] = value;
                }
            })
            
            const submittedData = await Request.post(url, dataObject)
                .catch(() => {
                    this._errorWrapper.classList.remove(this._hiddenClass);
                    scrollToTop();
                });

            this._exitCta.disabled = false;
            this._submitCta.disabled = false;

            if (submittedData) this.backToUrl(null, this._submitCta.dataset.target);
        } else {
          this.backToUrl(event);
        }
    }

    hasChanges() {
        if (this._activityInitial !== this._activityCurrent)
            return true;

        if ((this._interestInitial ?? []).join(',') !== (this._interestCurrent ?? []).join(','))
            return true;

        if (this._marketingConsentInitial !== this._marketingConsentCurrent)
            return true;

        if (this._thirdPartyMarketingConsentInitial !== this._thirdPartyMarketingConsentCurrent)
            return true;
       
		if (this._myWimbledonOptInInitial !== this._myWimbledonOptInCurrent)
            return true;

        if (this._communicationSubscriptionsInitial !== this._communicationSubscriptionsCurrent)
            return true;

        return false;
    }

    exitEditing(event) {
        if (this.hasChanges()) {
            this._exitModal.show()
        } else {
            this.backToUrl(event);
        }
    }

    backToUrl(event, redirectUrl = null) {
        const rootUrl = window.location.origin
        const url = redirectUrl || event.currentTarget.dataset.target;
        window.location.href = `${rootUrl}${url}`;
    }

}

const globalActivityAndInterests = new ActivityAndInterests();

export default globalActivityAndInterests;

